import { Navigate } from "react-router-dom";
import { isAccessTokenValid, clearClientSession } from "./authTokenUtils";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token || !isAccessTokenValid(token)) {
    if (token) clearClientSession();
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
